import React, { useState } from 'react'
import { autocompleteHelpers } from 'elentari'
import usuariosRepository from './UsuariosRepository'
import Autocomplete from '../../components/Autocomplete'
const { toOption } = autocompleteHelpers

export const loadUsuarios = async inputValue => {
  const response = await usuariosRepository.list({
    query: {
      usuario: inputValue,
      order: 'usuario asc'
    },
    paginate: {
      limit: 10
    },
    where: {
      usuarioInativado: 'nao'
    }
  })
  if (response.ok) {
    return response.data.map(toOption('usuario'))
  }
  return []
}

export const loadAnalistas = async inputValue => {
  const response = await usuariosRepository.listAnalistas({
    usuario: inputValue,
    order: 'usuario asc',
    limit: 10
  })
  if (response.ok) {
    return response.data.map(toOption('usuario'))
  }
  return []
}

export const loadAnalistasOp = async inputValue => {
  const response = await usuariosRepository.listAnalistasOp({
    usuario: inputValue,
    order: 'usuario asc',
    limit: 10
  })
  if (response.ok) {
    return response.data.map(toOption('usuario'))
  }
  return []
}

export const loadGestores = async inputValue => {
  const response = await usuariosRepository.list({
    query: {
      usuario: inputValue,
      realm: 'gestor',
      order: 'usuario asc'
    },
    paginate: {
      limit: 10
    }
  })
  if (response.ok) {
    return response.data.map(toOption('usuario'))
  }
  return []
}

export const loadEmbarcadores = async inputValue => {
  const response = await usuariosRepository.list({
    query: {
      usuario: inputValue,
      realm: 'embarcador',
      order: 'usuario asc'
    },
    paginate: {
      limit: 10
    }
  })
  if (response.ok) {
    return response.data.map(toOption('usuario'))
  }
  return []
}

export const loadUsuariosConsulta = async inputValue => {
  const response = await usuariosRepository.list({
    query: {
      usuario: inputValue,
      realm: 'usuario_consulta',
      order: 'usuario asc'
    },
    paginate: {
      limit: 10
    }
  })

  if (response.ok) {
    return response.data.map(toOption('usuario'))
  }
  return []
}
export const loadAnalistasAdmin = async inputValue => {
  const response = await usuariosRepository.listAnalistasAdmin({
    usuario: inputValue,
    order: 'usuario',
    limit: 10
  })
  if (response.ok) {
    return response.data.map(toOption('usuario'))
  }
  return []
}

export const loadAnalistasOpAdmin = async inputValue => {
  const response = await usuariosRepository.listAnalistasOpAdmin({
    usuario: inputValue,
    order: 'usuario',
    limit: 10
  })
  if (response.ok) {
    return response.data.map(toOption('usuario'))
  }
  return []
}

export const loadAnalistasAnalistasOpAdmin = async inputValue => {
  const response = await usuariosRepository.loadAnalistasAnalistasOpAdmin({
    usuario: inputValue,
    order: 'usuario',
    limit: 10
  })
  if (response.ok) {
    return response.data.map(toOption('usuario'))
  }
  return []
}

const UsuarioAutocomplete = props => {
  const [inputFocused, setInputFocused] = useState(false);

  const handleFocus = () => {
    if (!inputFocused) setInputFocused(true);
  };

  let loadOptions = loadUsuarios
  switch (props.realm) {
    case 'analista':
      loadOptions = loadAnalistas
      break
    case 'gestor':
      loadOptions = loadGestores
      break
    case 'analistaadmin':
      loadOptions = loadAnalistasAdmin
      break
    case 'analistaOp':
      loadOptions = loadAnalistasOp
      break
    case 'analistaOpAdmin':
      loadOptions = loadAnalistasOpAdmin
      break
    case 'analistaAdmin':
      loadOptions = loadAnalistasAnalistasOpAdmin
      break
    case 'embarcador':
      loadOptions = loadEmbarcadores
      break
    case 'usuario_consulta':
      loadOptions = loadUsuariosConsulta
      break
    default:
      break
  }
  return (
    <Autocomplete
      {...props}
      repository={usuariosRepository}
      labelOption="usuario"
      loadOptions={inputFocused ? loadOptions : async () => []}
      onFocus={handleFocus}
      defaultOptions={false}
    />
  )
}

export default UsuarioAutocomplete
